/*
 * 分享相关接口
 * @Author: wangminghua
 * @Date: 2022-04-22 15:10:23
 * @Last Modified by: wangminghua
 * @Last Modified time: 2022-04-25 13:49:42
 */

import axios from '@/utils/request'

export async function getShare (id) {
  return axios.get('/map/map/share/noncestr', { params: { noncestr: id } }).then(({ data }) => data)
}
// 根据分享串获取模板配置
export async function getShareTemplate (obj) {
  return axios.get('/map/map/template/share/noncestr', { params: obj }).then(({ data }) => data)
}
/**
 * 密码校验
 * @param {Object} param0
 * @returns
 */
export async function passwordChecking ({ noncestr, password }) {
  return axios.post('/map/map/share/valid/password', { noncestr, password }).then(({ data }) => data)
}

/**
 * 更新检测
 * @param {string} noncestr
 * @param {number} timestamp
 * @returns
 */
export async function updateInspection (noncestr, timestamp) {
  return axios.get('/map/map/share/update/flag', { params: { noncestr, timestamp } }).then(({ data }) => data)
}
// 检验模板分享是否失效
export async function templateEdateInspection (mapId, noncestr) {
  return axios.get('/map/map/template/share/check', { params: { mapId, noncestr } }).then(({ data }) => data)
}

export {
  axios
}
